module.exports = __webpack_public_path__ + "img/home.8cbfdbf6.jpg";